import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { useObjectPropertyGet, useObjectPropertyUpdate } from '../api/object-properties'
import { ObjectPropertiesForm } from './object-properties-form'

export function ObjectPropertiesEdit({ kind }: { kind?: string }) {
	const { object = kind, id = '' } = useParams<{ object: string; id: string }>()
	if (!object) throw new Error('Invalid invocation')
	const { data, isSuccess, dataUpdatedAt } = useObjectPropertyGet(id)
	const { mutate, isPending } = useObjectPropertyUpdate(id)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<ObjectPropertiesForm
			object={object}
			key={dataUpdatedAt}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
		/>
	)
}
